import React, {Component} from 'react';
import Modal from 'react-modal';
import Select from 'react-select';

import Avatar from '../avatar';
import styles from './styles.module.scss';
import Spinner from 'shared_features/spinner';
import EmailField from './EmailField';

class View extends Component {

    constructor(props) {
        super(props);

        this.state = {
            image: null,
            firstNameError: null,
            lastNameError: null,
            selectedTeamIdFallback: null
        };
    }

    // TODO: Consider having image be in the redux store instead of do a boolean check
    componentWillReceiveProps(nextProps) {
        if (nextProps.isShowing !== this.props.isShowing) {
            this.setState({ 
                image: null,
                firstNameError: null,
                lastNameError: null,
                selectedTeamIdFallback: null
            });
        }
        
        // Update selectedTeamIdFallback when selectedTeamId changes (even if it's null)
        if (nextProps.selectedTeamId !== this.props.selectedTeamId) {
            this.setState({
                selectedTeamIdFallback: nextProps.selectedTeamId
            });
            
            // When the team changes, ensure we log which groups should be available
            if (nextProps.selectedTeamId && nextProps.groups && nextProps.groups.length > 0) {
                const teamGroups = nextProps.groups.filter(group => 
                    group.team_id === nextProps.selectedTeamId);
                console.log("Team changed, available groups:", teamGroups);
            }
        }
    }

    // Clear field errors when user types
    handleNameChange = (field, value) => {
        if (field === 'first_name') {
            this.setState({ firstNameError: null });
            this.props.updateFirstName(value);
        } else if (field === 'last_name') {
            this.setState({ lastNameError: null });
            this.props.updateLastName(value);
        } else if (field === 'middle_name') {
            this.props.updateMiddleName(value);
        }
    }

    _renderAvatar() {
        if (!this.props.showAvatarOption) {
            return null;
        }

        const image = this.state.image 
            ? URL.createObjectURL(this.state.image)
            : "https://profiles.reponestrength.com/default.png";
        return (<div className={styles.avatar}>
                    <Avatar
                        imageURL={image}
                        uploadEnabled={false}
                        description="+ Upload athlete photo"
                        upload={(image)=>this.setState({image: image}) } />
                </div>);
    }

    _renderMetadata() {
        return (
            <div>
                <div className={styles.horizontalGrid}>
                    <div className={styles.label}>Team</div>
                    <div className={styles.label}>Group</div>
                    <div></div>
                </div>
                <div className={styles.horizontalGrid}>
                    <div>{this._renderTeamSelect()}</div>
                    <div>{this._renderGroupSelect()}</div>
                    <div></div>
                </div>
            </div>
        );
    }

    _renderTeamSelect() {
        let value = null;
        let teams = [];
        
        console.log("_renderTeamSelect - selectedTeamId:", this.props.selectedTeamId);
        console.log("_renderTeamSelect - teams:", this.props.teams);
        console.log("_renderTeamSelect - fallbackId:", this.state.selectedTeamIdFallback);
        
        // Use fallback from state ONLY if selectedTeamId is explicitly undefined (not if it's null)
        // This is important to distinguish between "no team selected" (null) and "not yet loaded" (undefined)
        const effectiveTeamId = this.props.selectedTeamId !== undefined ? 
            this.props.selectedTeamId : 
            this.state.selectedTeamIdFallback;
            
        console.log("_renderTeamSelect - effectiveTeamId after logic:", effectiveTeamId);
        
        // Check if teams data is available
        if (this.props.teams && this.props.teams.length > 0) {
            for (var team of this.props.teams) {
                const option = { 
                    value: team.id, 
                    label: team.name,
                    defaultGroupId: team.defaultGroupId 
                };
                teams.push(option);
                if (team.id === effectiveTeamId) {
                    value = option;
                }
            }
        }

        // If teamReadOnly is true, render a text field instead of a dropdown
        if (this.props.teamReadOnly) {
            const teamName = value ? value.label : "(No team)";
            return (
                <div className={styles.readOnlyField}>{teamName}</div>
            );
        }

        // Add styles for vertical centering of all elements including placeholder
        const centeringStyles = {
            control: (provided) => ({
                ...provided,
                minHeight: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                paddingTop: 0,
                paddingBottom: 0
            }),
            placeholder: (provided) => ({
                ...provided,
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                margin: 0,
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)'
            }),
            singleValue: (provided) => ({
                ...provided,
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                margin: 0,
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)'
            }),
            valueContainer: (provided) => ({
                ...provided,
                display: 'flex',
                alignItems: 'center',
                height: '38px',
                padding: '0 8px',
                position: 'relative'
            }),
            input: (provided) => ({
                ...provided,
                margin: 0,
                padding: 0
            }),
            indicatorsContainer: (provided) => ({
                ...provided,
                height: '38px',
                alignItems: 'center'
            }),
            dropdownIndicator: (provided) => ({
                ...provided,
                padding: '0 8px'
            }),
            clearIndicator: (provided) => ({
                ...provided,
                padding: '0 8px'
            })
        };

        return (
            <Select
                name="team"
                value={value}
                options={teams}
                isClearable={true}
                isDisabled={!!this.props.teamReadOnly}
                clearable={true}
                deleteRemoves={false}
                styles={centeringStyles}
                onChange={(selectedOption) => {
                    console.log("Team onChange called with:", selectedOption);
                    if (this.props.teamReadOnly) return;
                    
                    // Always store the selection in component state to ensure it's displayed correctly
                    this.setState({ 
                        selectedTeamIdFallback: selectedOption ? selectedOption.value : null 
                    });
                    
                    if (selectedOption) {
                        console.log("Updating team to:", selectedOption.value);
                        // If updateTeam exists, call it. Otherwise, just handle group updates.
                        if (this.props.updateTeam) {
                            this.props.updateTeam(selectedOption.value);
                            console.log("Called updateTeam with value:", selectedOption.value);
                        }
                        
                        // Always update the group based on the team selection
                        if (this.props.updateGroup) {
                            const newGroupId = selectedOption.defaultGroupId || this.props.defaultOrgGroupId;
                            console.log("Auto-updating group to:", newGroupId, 
                                       "(defaultGroupId:", selectedOption.defaultGroupId, 
                                       "defaultOrgGroupId:", this.props.defaultOrgGroupId, ")");
                            this.props.updateGroup(newGroupId);
                        }
                    } else {
                        console.log("Clearing team selection");
                        // If updateTeam exists, call it.
                        if (this.props.updateTeam) {
                            this.props.updateTeam(null);
                            console.log("Called updateTeam with null value");
                        }
                        
                        // Always update the group when clearing team
                        if (this.props.updateGroup) {
                            console.log("Setting group to defaultOrgGroupId:", this.props.defaultOrgGroupId);
                            this.props.updateGroup(this.props.defaultOrgGroupId);
                        }
                    }
                }}
            />
        );
    }

    _renderGroupSelect() {
        let value = null;
        let groups = [];
        
        console.log("_renderGroupSelect - groupId:", this.props.groupId);
        console.log("_renderGroupSelect - groups:", this.props.groups);
        
        // Use the same logic as team select - only use fallback if selectedTeamId is undefined
        const effectiveTeamId = this.props.selectedTeamId !== undefined ? 
            this.props.selectedTeamId : 
            this.state.selectedTeamIdFallback;
            
        console.log("_renderGroupSelect - effectiveTeamId:", effectiveTeamId);
        
        // Check if groups data is available
        if (this.props.groups && this.props.groups.length > 0) {
            // Debug: Log the first group to see what properties it has
            if (this.props.groups.length > 0) {
                console.log("First group object:", this.props.groups[0]);
            }
            
            // Check if groups have team_id property
            const hasTeamIdProperty = this.props.groups.some(group => 'team_id' in group);
            console.log("Groups have team_id property:", hasTeamIdProperty);
            
            // Filter groups based on the selected team - check if team_id property exists
            let filteredGroups = this.props.groups;
            if (effectiveTeamId && hasTeamIdProperty) {
                filteredGroups = this.props.groups.filter(group => group.team_id === effectiveTeamId);
            }
                
            console.log("_renderGroupSelect - filteredGroups:", filteredGroups);
            
            for (var group of filteredGroups) {
                const option = { value: group.id, label: group.name };
                groups.push(option);
                if (group.id === this.props.groupId) {
                    value = option;
                }
            }
        }

        // If groupReadOnly is true, render a text field instead of a dropdown
        if (this.props.groupReadOnly) {
            const groupName = value ? value.label : "(No Group)";
            return (
                <div className={styles.readOnlyField}>{groupName}</div>
            );
        }

        // Add styles for vertical centering of all elements including placeholder
        const centeringStyles = {
            control: (provided) => ({
                ...provided,
                minHeight: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                paddingTop: 0,
                paddingBottom: 0
            }),
            placeholder: (provided) => ({
                ...provided,
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                margin: 0,
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)'
            }),
            singleValue: (provided) => ({
                ...provided,
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                margin: 0,
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)'
            }),
            valueContainer: (provided) => ({
                ...provided,
                display: 'flex',
                alignItems: 'center',
                height: '38px',
                padding: '0 8px',
                position: 'relative'
            }),
            input: (provided) => ({
                ...provided,
                margin: 0,
                padding: 0
            }),
            indicatorsContainer: (provided) => ({
                ...provided,
                height: '38px',
                alignItems: 'center'
            }),
            dropdownIndicator: (provided) => ({
                ...provided,
                padding: '0 8px'
            }),
            clearIndicator: (provided) => ({
                ...provided,
                padding: '0 8px'
            })
        };

        // Check if updateGroup function exists
        if (!this.props.updateGroup) {
            console.error("updateGroup function is not available in props");
        }

        return (
            <Select
                name="group"
                value={value}
                options={groups}
                isClearable={true}
                isDisabled={!!this.props.groupReadOnly}
                clearable={true}
                deleteRemoves={false}
                styles={centeringStyles}
                onChange={(selectedOption) => {
                    console.log("Group onChange called with:", selectedOption);
                    if (this.props.groupReadOnly) return;
                    
                    if (selectedOption) {
                        console.log("Updating group to:", selectedOption.value);
                        if (this.props.updateGroup) {
                            this.props.updateGroup(selectedOption.value);
                        } else {
                            console.error("updateGroup function not found");
                        }
                    } else {
                        console.log("Clearing group selection");
                        if (this.props.selectedTeamId && this.props.teams) {
                            const team = this.props.teams.find(t => t.id === this.props.selectedTeamId);
                            if (team && team.defaultGroupId && this.props.updateGroup) {
                                this.props.updateGroup(team.defaultGroupId);
                                return;
                            }
                        }
                        if (this.props.defaultOrgGroupId && this.props.updateGroup) {
                            this.props.updateGroup(this.props.defaultOrgGroupId);
                        } else if (this.props.updateGroup) {
                            this.props.updateGroup(null);
                        }
                    }
                }}
            />
        );
    }

    _renderRemove() {
        if (this.props.showRemove) {
            return <div className={styles.deleteButton} onClick={()=>window.confirm("Are you sure?") && this.props.remove()}>Remove athlete</div>
        }
    }

    _renderDone() {
        if (!this.props.showAvatarOption || !this.props.isUploadingAvatar) {
            const actionText = this.props.showAvatarOption ? "Create athlete" : "Save athlete";
            return <div className={styles.saveButton} onClick={()=> this.handleSave()}>{actionText}</div>;
        } else {
            return <div>
                <Spinner />
                <div className={styles.saveButton}>Creating...</div>
            </div>;
        }
    }

    // Handle key press events
    handleKeyDown = (e) => {
        // Check if Enter key was pressed
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleSave();
        }
    }

    // Validate form fields and save athlete
    handleSave = () => {
        let isValid = true;
        
        console.log("handleSave called - Current props:", {
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            selectedTeamId: this.props.selectedTeamId,
            groupId: this.props.groupId,
            fallbackTeamId: this.state.selectedTeamIdFallback,
            email: this.props.email,
            inviteStatus: this.props.inviteStatus
        });
        
        // Validate first name
        if (!this.props.firstName || !this.props.firstName.trim()) {
            this.setState({ firstNameError: 'First name is required' });
            isValid = false;
        }
        
        // Validate last name
        if (!this.props.lastName || !this.props.lastName.trim()) {
            this.setState({ lastNameError: 'Last name is required' });
            isValid = false;
        }
        
        // Validate email if required
        if (this.props.requireEmail && (!this.props.email || !this.props.email.trim())) {
            if (this.props.updateEmailError) {
                this.props.updateEmailError('Email is required');
            }
            isValid = false;
        }
        
        // Email format validation
        if (this.props.email && this.props.inviteStatus === 'none') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.props.email)) {
                if (this.props.updateEmailError) {
                    this.props.updateEmailError('Please enter a valid email address');
                } else {
                    alert('Please enter a valid email address.');
                }
                isValid = false;
            }
        }
        
        // If all validation passes, proceed with save
        if (isValid) {
            console.log("Validation passed, calling save with selected team:", this.props.selectedTeamId, 
                       "and group:", this.props.groupId);
            this.props.save(this.state.image);
        } else {
            console.log("Validation failed, not saving");
        }
    }

    render() {
        const title = this.props.showAvatarOption ? "New Athlete" : "Athlete Profile";
        
        return (
            <Modal
                className={styles.modal}
                overlayClassName={styles.overlay}
                isOpen={this.props.isShowing}
                onRequestClose={()=>this.props.closeModal()}>

                <div className={styles.header}>
                    <div className={styles.cardTitle}>{title}</div>
                    <button
                        type="button"
                        className={styles.closeButton}
                        onClick={() => this.props.closeModal()}
                    >
                        ✕
                    </button>
                </div>
                {this._renderAvatar()}
                <div className={styles.label}>Name</div>
                <div className={styles.horizontalGrid}>
                    <div>
                        <input
                            type="text"
                            placeholder="First"
                            value={this.props.firstName}
                            onChange={(event) => this.handleNameChange('first_name', event.target.value)}
                            onKeyDown={this.handleKeyDown}
                            className={this.state.firstNameError ? styles.fieldError : ''}
                        />
                        {this.state.firstNameError && (
                            <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{this.state.firstNameError}</div>
                        )}
                    </div>
                    <input 
                        type="text"
                        placeholder="Middle (optional)"
                        value={this.props.middleName}
                        onChange={(event) => this.handleNameChange('middle_name', event.target.value)}
                        onKeyDown={this.handleKeyDown}
                    />
                    <div>
                        <input 
                            type="text"
                            placeholder="Last"
                            value={this.props.lastName}
                            onChange={(event) => this.handleNameChange('last_name', event.target.value)}
                            onKeyDown={this.handleKeyDown}
                            className={this.state.lastNameError ? styles.fieldError : ''}
                        />
                        {this.state.lastNameError && (
                            <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{this.state.lastNameError}</div>
                        )}
                    </div>
                </div>

                {this._renderMetadata()}
                
                {/* New Email Field Component */}
                <EmailField 
                    email={this.props.email} 
                    inviteStatus={this.props.inviteStatus} 
                    updateEmail={this.props.updateEmail}
                    cancelInvite={this.props.cancelInvite}
                    requireEmail={!!this.props.requireEmail}
                    invitedEmail={this.props.invitedEmail}
                    emailError={this.props.emailError}
                    emailReadOnly={!!this.props.emailReadOnly}
                    isLoadingEmail={!!this.props.isLoadingEmail}
                    isEditing={!!this.props.isShowing && !this.props.showAvatarOption}
                    isCreating={!!this.props.isShowing && !!this.props.showAvatarOption && !this.props.showRemove}
                    onEnterPress={this.handleSave}
                />

                <div className={styles.optionsContainer}>
                    {this._renderRemove()}
                    {this._renderDone()}
                </div>
            </Modal>
        );
    }

}

export default View;



